import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import {
  loadingToggleAction,
  loginAction,
} from "../../store/actions/AuthActions";
// image
import logo2 from "../../images/red-no-logo.png";

function Login(props) {
  const [email, setEmail] = useState("");
  const [valid, setValid] = useState(true);
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState("");
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  //setEmail('');
  //setPassword('123456');
  function onLogin(e) {
    e.preventDefault();
	setLoader(true)
    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      errorObj.email = "Email is Required";
      error = true;
    }
    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }
    dispatch(loadingToggleAction(true));
    dispatch(loginAction(email, password, props.history,setLoader));

  }

  return (
    <div className="login-wrapper">
      <div className="login-aside-left ">
        <Link className="login-logo align-center ">
          <img
            className=""
            src={logo2}
            alt=""
            style={{height:250,width:400}}
          />
        </Link>

        <div className="login-description">
          <div>
            <h2 className="text-white">Welcome to Go Sampl</h2>
          </div>
          {/* <h2 className="text-white mb-4">Check the Status</h2>
					<p className="fs-12">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters,</p> */}
          {/* <ul className="social-icons mt-4">
						<li><Link to={"#"}><i className="fa fa-facebook"></i></Link></li>
						<li><Link to={"#"}><i className="fa fa-twitter"></i></Link></li>
						<li><Link to={"#"}><i className="fa fa-linkedin"></i></Link></li>
					</ul> */}
          <div className="mt-5">
            {/* <Link to={"#"} className="text-white mr-4">Privacy Policy</Link>
						<Link to={"#"} className="text-white mr-4">Contact</Link> */}
            <Link to={"#"} className="text-white">
              © {new Date().getFullYear()} Hikizo Private Limited
            </Link>
          </div>
        </div>
      </div>
      <div className="login-aside-right">
        <div className="row m-0 justify-content-center h-100 align-items-center">
          <div className="col-xl-6 col-xxl-8">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className=" mb-3">
                      {/*  <Link to="/">
								<img src={logo} alt="" />
                            </Link> */}
                    </div>
                    <h4 className=" mb-4 ">Sign in by entering information</h4>
                    {props.errorMessage && (
                      <div className="text-danger">{props.errorMessage}</div>
                    )}
                    {props.successMessage && (
                      <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                        {props.successMessage}
                      </div>
                    )}
                    <form onSubmit={onLogin}>
                      <div className="form-group">
                        <label className="mb-2 ">
                          <strong>Email</strong>
                        </label>
                        <input
                        required
                          type="email"
                          className={`form-control ${
                            valid ? "text-primary" : "text-danger"
                          }`}
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            if (re.test(e.target.value.toLowerCase())) {
                              setValid(true);
                            } else {
                              setValid(false);
                            }
                          }}
                          placeholder="example@gmail.com"
                          //defaultValue="abcd@gmail.com"
                        />
                        {errors.email && (
                          <div className="text-danger fs-12">
                            {errors.email}
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="mb-2 ">
                          <strong>Password</strong>
                        </label>
                        <input
                        required
                          type="password"
                          className="form-control"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        {errors.password && (
                          <div className="text-danger fs-12">
                            {errors.password}
                          </div>
                        )}
                      </div>
                      <div className="form-row d-flex justify-content-between mt-4 mb-2">
                        {/* <div className="form-group">
								  <div className="custom-control custom-checkbox ml-1 ">
									<input
									  type="checkbox"
									  className="custom-control-input"
									  id="basic_checkbox_1"
									/>
									<label
									  className="custom-control-label"
									  htmlFor="basic_checkbox_1"
									>
									  Remember my preference
									</label>
								  </div>
								</div> */}
                        {/* <div className="form-group">
								  <Link className="text-primary" to="page-forgot-password">
									Forgot Password ?
								  </Link>
								</div> */}
                      </div>
                      <div className="text-center">
                        {loader ? (
                          <Spinner animation="border" variant="primary" />
                        ) : (
                          <button
                            type="submit"
                            className="btn btn-primary btn-block"
                          >
                            Sign In
                          </button>
                        )}
                      </div>
                    </form>
                    <div className="new-account mt-3">
                      {/* <p className="">
								Don't have an account?{" "}
								<Link className="text-primary" to="./page-register">
								  Sign up
								</Link>
							  </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(Login);
